
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import Properties from './Pages/Properties';
import AddProperty from './Pages/AddProperty';
import HomeContent from './Pages/HomeContent';
import EditProperty from './Pages/EditProperty';
import Testimonial from './Pages/Testimonial';
import TestimonialList from './Pages/TestimonialList';
import EditTestimonial from './Pages/EditTestimonial';
import AddEvents from './Pages/AddEvents';
import Events from './Pages/Events';
import EditEvent from './Pages/EditEvent';
import AllBolg from './Pages/AllBolg';
import AddBlog from './Pages/AddBlog';
import EditBlog from './Pages/EditBlog';
import {useSelector,useDispatch} from "react-redux"
import {useNavigate} from "react-router-dom"
import { loadUser } from './actions/userActions';
import { useEffect } from 'react';
import Login from './Pages/Login';
import AddFaq from './Pages/AddFaq';
import Faq from './Pages/Faq';
import HomeBannerList from './Pages/HomeBannerList';
import EditHomeBanner from './Pages/EditHomeBanner';
import HomeProperties from './Pages/HomeProperties';
import AddDaily from './Pages/AddDaily';
import AddArticle from './Pages/AddArticle';
function App() {
  const navigate = useNavigate()
  const { error, loading, isAuthenticated, numberAdded,user, userProfile } = useSelector(
    (state) => state.user
  );

  const dispatch = useDispatch()
  useEffect(() => {
    if(!isAuthenticated){
      navigate("/login")
    }
    

    if(isAuthenticated) {
    dispatch(loadUser(user));
   

  }
  }, [isAuthenticated,navigate])
  return (
    <div className="App">
     <Routes>
     <Route exact path="/" element={<Home /> }   />
     <Route exact path="/properties" element={<Properties /> }   />
     <Route exact path="/property/:id" element={<EditProperty /> }   />
     <Route exact path="/add-property" element={<AddProperty /> }   />
     <Route exact path="/add-daily" element={<AddDaily /> }   />
     <Route exact path="/home-content" element={<HomeContent />  }   />
     <Route exact path="/home-properties" element={<HomeProperties />  }   />
     <Route exact path="/home-list" element={<HomeBannerList />  }   />
     <Route exact path="/homeCarousel/:id" element={<EditHomeBanner />  }   />
     <Route exact path="/add-testimonial" element={<Testimonial />  }   />
     <Route exact path="/testimonials" element={<TestimonialList />  }   />
     <Route exact path="/testimonial/:id" element={<EditTestimonial /> }   />
     <Route exact path="/add-events" element={<AddEvents /> }   />
     <Route exact path="/events" element={<Events /> }   />
     <Route exact path="/event/:id" element={<EditEvent /> }   />
     <Route exact path="/blogs" element={<AllBolg /> }   />
     <Route exact path="/blog/:id" element={<EditBlog /> }   />
     <Route exact path="/add-blog" element={<AddBlog /> }   />
     <Route exact path="/add-articles" element={<AddArticle /> }   />
     <Route exact path="/add-faqs" element={<AddFaq /> }   />
     <Route exact path="/faqs" element={<Faq /> }   />
     <Route exact path="/login" element={<Login /> }   />
     </Routes>
    </div>
  );
}

export default App;
